import { SvgProps } from '..';

export const SwapIcon: React.FC<React.PropsWithChildren<SvgProps>> = (
  props
) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${props.id}_swap_clip0)`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1348 2.99128C13.0204 1.87681 11.6005 1.11785 10.0547 0.810359C8.50889 0.50287 6.90663 0.660669 5.45052 1.2638C3.99442 1.86693 2.74986 2.88831 1.87424 4.19877C0.998613 5.50922 0.53125 7.04991 0.53125 8.62598C0.53125 10.2021 0.998613 11.7427 1.87424 13.0532C2.74986 14.3637 3.99442 15.385 5.45052 15.9882C6.90663 16.5913 8.50889 16.7491 10.0547 16.4416C11.6005 16.1341 13.0204 15.3752 14.1348 14.2607C15.6283 12.7658 16.4672 10.7391 16.4672 8.62598C16.4672 6.51287 15.6283 4.48619 14.1348 2.99128ZM3.74728 9.94215L8.22412 5.46531H6.91034V4.40281H10.0378V7.53028H8.97531V6.2165L4.49847 10.6933L3.74728 9.94215ZM10.1334 11.8334V12.8959H6.91565V9.67919H7.97815V11.0822L12.4406 6.61972L13.1918 7.3709L8.72934 11.8334H10.1334Z"
          fill="#B8BBC6"
        />
      </g>
      <defs>
        <clipPath id={`${props.id}_swap_clip0`}>
          <rect width="17" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
